/**
 * This react-query custom hook returns all the available related entities for a given entity template Id
 */

import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { fetchEntityRecordsListBySearch } from '../../services/entityServices'
import { ISelectorForRelations } from '../../services/apiInterfaces'

const useGetAvailableRelatedEntities = (
    orgId: string,
    childEntityTemplateId: string,
    parentEntityTemplateId: string,
    searchText: string = '',
    includeAttributes: boolean = true,
    enableAPICall: boolean = true,
): UseQueryResult<ISelectorForRelations[], Error> => {
    return useQuery<ISelectorForRelations[]>({
        queryKey: [
            'availableRelatedEntities',
            orgId,
            childEntityTemplateId,
            parentEntityTemplateId,
            searchText,
        ],
        queryFn: async () => {
            if (!childEntityTemplateId || !parentEntityTemplateId) {
                return []
            }
            return fetchEntityRecordsListBySearch(
                orgId,
                childEntityTemplateId,
                parentEntityTemplateId,
                searchText,
                includeAttributes,
            )
        },
        refetchOnWindowFocus: false,
        enabled: enableAPICall,
    })
}

export default useGetAvailableRelatedEntities
